export enum ClubOfficialsOptions {
  ADMINISTRATOR = 1,
  COACH = 2,
  PRESIDENT = 3,
  VICE_PRESIDENT = 4,
  MEMBER = 5,
  CASHIER = 6,
  ASSISTANT_COACH = 7
}
